import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Container, FormContactLetslink } from '../../components';

export interface LetsLinkContactProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkContact({
  className,
  ...props
}: LetsLinkContactProps) {
  return (
    <section className={className} {...props}>
      <Container variant="container_small">
        <AnimationOnScroll
          delay={0}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeIn"
        >
          <FormContactLetslink />
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
